import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsBuildingRoutingModule } from './forms-builder-routing.module';
import { FormsBuilderComponent } from './forms-builder.component';
import { FormsGlobals } from '../../../models/forms/forms.enum';

import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    FormsBuilderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormsBuildingRoutingModule,

    MatRadioModule,
    MatCheckboxModule,
    MatSliderModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
  ],
  exports: [
    FormsBuilderComponent
  ],
  providers: [
    FormsGlobals
  ]
})
export class FormsBuilderModule { }
